import React from 'react';

import './css/styles.css';

class BotonGhostCuadrado extends React.Component{
    render(){
        return(
            <div className="row">
                <div className={`col ${this.props.boxLeft}`}></div>
                <div className={`col ${this.props.boxCenter}`}>
                    <p className="c-botonghost secondary">{this.props.text}</p>
                </div>
                <div className={`col ${this.props.boxRight}`}></div>
            </div>
        );
    }
}

export default BotonGhostCuadrado;